import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { NavSectionDef } from '@/app/navigation';

import { NAV_SECTION_HEADING } from './nav-styles';
import { SidebarLink } from './SidebarLink';

export function SidebarSection({ section }: { section: NavSectionDef }): ReactNode {
  const { t } = useTranslation();

  return (
    /*
     * Grupper uten overskrift skilles med luft (103): Oversikt-gruppen, den personlige og
     * organisasjonens felles sider står som tre blokker over streken.
     */
    <div
      className={section.titleKey ? 'flex flex-col gap-px' : 'flex flex-col gap-px pt-2 first:pt-0'}
      data-testid={`nav-section-${section.id}`}
    >
      {section.titleKey ? (
        <h2 className={`px-2 pt-3 pb-1 ${NAV_SECTION_HEADING}`}>{t(section.titleKey)}</h2>
      ) : null}
      {section.entries.map((entry) => (
        <SidebarLink key={entry.id} entry={entry} />
      ))}
    </div>
  );
}
